var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLineMediaClapperboardLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_3598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99659 11.6667L13.8466 5H19.9966L16.1466 11.6667H9.99659ZM19.9966 11.6667L23.8466 5H29.9966L26.1466 11.6667H19.9966ZM29.9966 11.6667L33.8466 5H35.0133C35.9266 5 36.6666 5.74167 36.6666 6.655V33.345C36.6635 33.7827 36.4884 34.2016 36.1791 34.5113C35.8697 34.821 35.451 34.9965 35.0133 35H4.98659C4.54794 34.9996 4.12741 34.825 3.8174 34.5147C3.50739 34.2043 3.33325 33.7836 3.33325 33.345V6.655C3.3363 6.2173 3.51142 5.79836 3.82077 5.4887C4.13013 5.17903 4.54889 5.00349 4.98659 5H9.99659L6.66659 10.7667V31.6667H33.3333V11.6667H29.9966Z",
    fill: "#8F8F8F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_3598"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineMediaClapperboardLine);
export default __webpack_public_path__ + "static/media/Line__Media--clapperboard-line.352b3e7c4887d379cf71f95a46603628.svg";
export { ForwardRef as ReactComponent };